















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableList } from '@/shims-global'
import MainTitle from '../_components/MainTitle.vue'
import SubTitle from '../_components/SubTitle.vue'
import Page8Chart from '../_components/charts/Page8Chart.vue'
@Component({
  components: {
    MainTitle,
    SubTitle,
    Page8Chart
  }
})
export default class extends Vue {
  @Prop({}) private data!: any
  private list: any = [];
  private colorList: any = ['#F87A52', '#FFB900', '#00B66C', '#3A91FF', '#A187FF']
  private colorList1: any = ['#F87A52', '#FFB900', '#00B66C', '#3A91FF', '#A187FF', '#32C5FF']
  private levelList: any = ['很差', '较差', '一般', '良好', '优秀']
  private chartData: any = [
    [10, 30, 40],
    [20, 20, 20],
    [30, 30, 30],
    [40, 40, 40]
  ]
  private chartNames: any = [
    '小班级',
    '中班',
    '大班'
  ]
  created() {
    this.list = this.data.array
    this.list.map((v:any, vIndex:any) => {
      v.levelList = []
      v.chartData = []
      v.chartNames = []
      v.groupGradeAnalysisVos[0].energyZoneScorePercentVos.map(q => {
        v.levelList.push(q.scoreTypeIntro)
      })
      v.groupGradeAnalysisVos.map((q:any, qIndex:any) => {
        v.chartNames.push(q.ClassroomTypeIntro)
        q.energyZoneScorePercentVos.map((z:any, zIndex:any) => {
          if (!v.chartData[zIndex]) {
            v.chartData[zIndex] = []
          }
          v.chartData[zIndex][qIndex] = Number(z.percentStr)
        })
      })
    })
    console.info(this.list)
  }
}
